import type { OrderCaseState } from '../api/types';
import { labelFor } from '../ui/tones';

/** Human labels for pharmacy queue/detail — matches the legacy console: one order status only. */
export function pharmacyQueueLabel(state: OrderCaseState | string): string {
  switch (state) {
    case 'awaiting_dispense':
      return 'Awaiting dispense';
    case 'dispensed':
    case 'dispatched':
      // Legacy console keeps "Dispensed" even after courier tracking is saved.
      return 'Dispensed';
    case 'dispense_rejected':
      return 'Cancelled';
    default:
      return labelFor(state);
  }
}
